exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a[data-v-10ad21fc]{color:#3e6174;position:relative;display:block;line-height:21px;padding:10px 30px}a[data-v-10ad21fc]:hover{color:#5e7b85}a.active[data-v-10ad21fc]{color:#3e6174;background-color:#e6e6e6}a.active i[data-v-10ad21fc]{color:#3e6174!important}.submenu-content-box .listbrdr[data-v-10ad21fc]:active{color:#000}.submenu-content a[data-v-10ad21fc]{padding:11px 20px 10px 45px;position:relative}.submenu-content .leftmenu_icon[data-v-10ad21fc]{font-size:14px;color:inherit}.name[data-v-10ad21fc]{vertical-align:text-bottom}.collapse-item .card-content .card-content-box div a[data-v-10ad21fc]{padding-left:43px}.leftmenu_icon[data-v-10ad21fc]{margin-right:1px;line-height:22px;height:23px;width:20px;text-align:center;font-size:16px;color:#3e6174}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-10ad21fc","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/layouts/left-side/default/menu/MenuItem.vue
// module id = l4Mb
// module chunks = 1